'use client';

import { JSX } from 'react';

import { Toast } from '@videoblocks/design-system';
import { LoadingRing } from '@videoblocks/design-system/icons';

import { CATEGORY_TOAST_HREF } from '../../_context/activeTaskToastConfig';
import { ActiveTask } from '../../_context/types';
import { ToastTitle } from './ToastTitle';

interface AiToolkitToastProps {
    open: boolean;
    onOpenChange?: (open: boolean) => void;
    activeTask: ActiveTask;
}

export const AiToolkitToast = ({ open, onOpenChange, activeTask }: AiToolkitToastProps): JSX.Element | null => {
    if (!activeTask) return null;

    const { category, operation, status } = activeTask;
    const icon = status === 'inProgress' ? <LoadingRing className="size-6 animate-spin [&_path]:stroke-black" /> : null;

    return (
        <Toast
            open={open}
            onOpenChange={onOpenChange}
            variant={status === 'inProgress' ? 'neutral' : status === 'success' ? 'success' : 'error'}
            title={
                <ToastTitle
                    category={category}
                    operation={operation}
                    status={status}
                    href={CATEGORY_TOAST_HREF[category]}
                />
            }
            hasClose={false}
            icon={icon}
            viewportClassName="fixed bottom-4 left-4 right-4 md:left-auto md:w-full max-w-161 z-[1050]"
        />
    );
};
